import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "./styles.m.css";
import { Icon } from "../../../../atoms/icon";
import { LoadVuukle, GA } from "../../../../../integrations";
import { isPremium } from "../../../../../data/story";
import { humanizeDate } from "../../../../utils/time-format";
import { Link } from "@quintype/components";
import { fetchvuuklegetCommentCount } from "../../../../../api";

function CartoonStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const renderarticleFooter = get(props, ["renderarticleFooter"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const renderRelatedArticle = get(props, ["renderRelatedArticle"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const storyIndex = get(props, ["index"], 0);
  const handleExpandStory = get(props, ["handleExpandStory"], () => null);
  const [readMore, setReadMore] = useState(storyIndex !== 0);
  const story = get(props, ["story"], () => null);
  const cards = readMore ? (isPremium(story) ? [] : singleCard.slice(0, 1)) : singleCard;
  const storyId = get(props, ["story", "id"], "");

  const [showRelativeTime, setShowRelativeTime] = React.useState(false);

  const cardLength = cards.length;

  const expandComments = get(props, ["expandComments"], () => null);
  const [commentsCount, setCommentsCount] = useState(null);
  const handleChange = () => {
    const story = get(props, ["story"], () => null);
    LoadVuukle.register(story, props.config.vikatanHosts);
    GA.customEvent("Readmore-storyfeed", " Clicked", "articleloadmore");
    setReadMore(false);
    handleExpandStory();
  };

  useEffect(() => {
    setShowRelativeTime(true);
  }, []);

  const adShow = isPremium(story) ? !readMore : true;

  useEffect(() => {
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        setCommentsCount(res.data);
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }, []);

  const [showShare, setShowShare] = useState(false);

  const handleShareClick = () => {
    setShowShare(!showShare);
  };

  const scrollToComments = () => {
    expandComments();
    const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
    if (commentsWidgetContainer) {
      commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="page-content">
      <div className={`container ${styles["story-grid"]}`}>
        <div className={styles["main-content"]}>
          <article className={`${styles["story-body"]} js-story`}>
            <Breadcrumb subSection={section} config={props.config} />
            <div>
              <div>
                {renderHeaderCard("", true, true, true)}
                <p className={`${styles["subheadline"]} subheadline-main`}>{storyHeadline}</p>
                <div className={styles["published-time-wrap"]}>
                  {story["first-published-at"] && (
                    <span className={styles["published"]}>
                      Published:
                      <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                        {humanizeDate(story["first-published-at"], showRelativeTime ? "relative" : "absolute")}
                      </time>
                    </span>
                  )}
                  {story["last-published-at"] && (
                    <span className={styles["updated"]}>
                      Updated:
                      <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                        {humanizeDate(story["last-published-at"], showRelativeTime ? "relative" : "absolute")}
                      </time>
                    </span>
                  )}
                </div>
              </div>

              {cards &&
                cards.map((card, index) => {
                  return (
                    <React.Fragment key={card.id}>
                      <StoryCard
                        card={card}
                        story={props.story}
                        showCard={readMore}
                        index={index}
                        storyIndex={storyIndex}
                        cardLength={cardLength}
                        renderRelatedArticle={renderRelatedArticle}
                        config={props.config}
                      />
                    </React.Fragment>
                  );
                })}

              <div className={styles["audio-share-wrapper"]}>
                <div className={styles["audio-comments-share"]}>
                  <div>
                    <Link
                      href="https://whatsapp.com/channel/0029Va7F0Hj0bIdoYCCkqs41"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles["box-div"]}
                    >
                      <Icon type="icon-whatsapp" className={styles["whatsapp-channel-icon"]} />
                      <span className={styles["channel-txt"]}>Join Our Channel</span>
                    </Link>
                    {/* <Link
                      href="https://bit.ly/3J0OoJc"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${styles["box-div"]} ${styles["play-to-win"]}`}
                      style={{ padding: "0" }}
                    >
                      <img src="https://media.vikatan.com/vikatan/2024-03/2455867c-ef84-491e-be25-abd7a1e00de2/Play_to_win.gif" />
                    </Link> */}
                  </div>

                  <div className={styles["box-div"]} onClick={scrollToComments}>
                    <Icon type="comment" />
                    <span className={styles["channel-txt"]}>
                      {commentsCount !== null ? commentsCount[storyId] || 0 : 0}
                    </span>
                    <span className={`${styles["channel-txt"]} hidden-mobile`}>Comments</span>
                  </div>
                  <div
                    className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""} `}
                    onClick={handleShareClick}
                  >
                    <Icon type="socialshare" />
                    <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
                  </div>
                </div>

                <div className={styles["social-share-wrapper"]}>
                  {showShare && !readMore && renderSocialMedia("", false)}
                </div>
              </div>
            </div>
            {readMore && (
              <div className={styles["readmore-wrapper"]}>
                <div onClick={() => handleChange()} className={styles["read-more-button"]}>
                  <span>மேலும் படிக்க</span>
                  <div className={styles["arrows"]}>
                    <Icon type={"angle-right"} />
                    <Icon type={"angle-right"} />
                  </div>
                </div>
              </div>
            )}
            <div id="commentsWidgetContainer">{renderarticleFooter(readMore)}</div>
          </article>
          {renderFooter(readMore)}
        </div>
        {renderSidebar(adShow)}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any,
  metadata: PropTypes.shape({
    "reference-url": PropTypes.string
  })
});
CartoonStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  isAccessible: PropTypes.bool,
  relatedStories: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      story: story
    })
  ),
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  handleExpandStory: PropTypes.func,
  renderTextStoryHeaderCard: PropTypes.func
};

export { CartoonStory };
